import { useEffect } from "react";
import { Outlet } from "react-router";
import AuthLoader from "~/components/AuthLoader";
import { useAuth } from "~/context/AuthContext";
import { useNavigate } from "~/lib/team-router";

export default function OnboardingLayout() {
  const { isLoading, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      navigate("/login");
    }
  }, [isAuthenticated, isLoading, navigate]);

  if (isLoading) {
    return <AuthLoader />;
  }

  if (!isAuthenticated) {
    return;
  }

  return <Outlet />;
}
